import { render } from "./CatalogCardsComp.vue?vue&type=template&id=e670cd1c&scoped=true&ts=true"
import script from "./CatalogCardsComp.vue?vue&type=script&lang=ts"
export * from "./CatalogCardsComp.vue?vue&type=script&lang=ts"

import "./CatalogCardsComp.vue?vue&type=style&index=0&id=e670cd1c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e670cd1c"]])

export default __exports__